import React from 'react';
import {
    DatePicker,
    IconButton,
    Paper,
    TextField,
    Divider,
    FlatButton,
    SelectField,
    MenuItem,
    Snackbar,
} from 'material-ui';
import PrevArrow from 'material-ui/svg-icons/hardware/keyboard-arrow-left';
import NextArrow from 'material-ui/svg-icons/hardware/keyboard-arrow-right';
import UndoIcon from 'material-ui/svg-icons/content/undo';
import req from 'superagent';
import cfg from 'cfg';
import moment from 'moment';
import _ from 'lodash';
import { connect } from 'react-redux';
import { yCenter } from 'dash-front/campaign/components/helpers';
import { isNullOrUndefined, addToQuery } from 'dash-front/helpers';

const { ss2 } = cfg.apis;
const withQueryParams = (...params) =>
    connect(state =>
        params.reduce((acc, param) => {
            acc[param] = _.get(state.routing.location, ['query', param]);
            return acc;
        }, {}),
    );

const getEventLabel = event => `${event.homeName} - ${event.awayName}`;

const KEY_OPTIONS = [
    { label: 'Match link', value: 'matchPageLink' },
    { label: 'Channel', value: 'channels' },
    { label: 'Liveblog', value: 'lbid' },
];

const CHANNELS = [['DR 1'], ['DR 2'], ['DR 3'], ['DRTV'], ['TV 2'], ['TV 2 SPORT'], ['TV 2 PLAY']];

const emptyOption = Symbol(null);

const getVal = (key, event) => {
    const value = event[key];
    switch (key) {
        case 'channels': {
            if (Array.isArray(value)) {
                const channel = _.head(value);
                return CHANNELS.find(([el]) => el === channel) || emptyOption;
            }
            return emptyOption;
        }
        default: {
            return isNullOrUndefined(value) || _.isObject(value) || Array.isArray(value) ? null : value;
        }
    }
};

const EventInput = withQueryParams('property', 'dev')(
    class _EventInput extends React.PureComponent {
        constructor(props) {
            super(props);
            const { property } = props;
            const value = property ? getVal(property, props.event) : '';
            this.state = {
                value,
                key: property || '',
                initialValue: value,
                snackBarText: '',
                success: null,
            };
        }

        componentWillReceiveProps(props) {
            if (this.props.property !== props.property) {
                this.onKeyChange(props.property);
                const value = getVal(props.property, props.event);
                this.setState({ initialValue: value });
            }
        }

        onChange = (event, value) => {
            const { name } = event.target;
            this.setState({ [name]: value });
        };

        onKeyChange = keyName => {
            const { event } = this.props;
            const value = getVal(keyName, event);
            this.setState({
                key: keyName,
                initialValue: value,
                value,
            });
        };

        showSnackBar = (text, isError) => {
            this.setState({ snackBarText: text, success: !isError });
            setTimeout(() => {
                this.setState({ snackBarText: '' });
            }, 3 * 1000);
        };

        save = e => {
            e.preventDefault();
            const { key, value } = this.state;
            const { event, appName } = this.props;
            const { eventId } = event;
            req.put(`${ss2}/admin/kv`)
                .send({
                    eventId,
                    appName,
                    key,
                    value: value === emptyOption ? null : value,
                })
                .then(() => {
                    this.setState({ initialValue: value });
                    this.showSnackBar(`${getEventLabel(event)} saved`, false);
                    if (typeof this.props.onSave === 'function') {
                        this.props.onSave();
                    }
                })
                .catch(() => {
                    this.showSnackBar(`Error while updating ${getEventLabel(event)}`, true);
                });
        };

        undo = () => {
            this.setState(({ initialValue }) => ({ value: initialValue }));
        };

        render() {
            const { event, appName, dev } = this.props;
            const { key, value, initialValue, snackBarText, success } = this.state;
            const canSubmit = key && appName;
            const valueChanged = initialValue !== value;
            return (
                <div
                    style={{
                        ...yCenter,
                        marginTop: 8,
                        padding: 8,
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                    }}
                >
                    <div>
                        <p>{getEventLabel(event)}</p>
                        <small>
                            eventId: {event.eventId} {moment(event.startDate).format('DD-MMM HH:mm')}
                        </small>
                    </div>
                    <div style={{ ...yCenter, flexWrap: 'wrap' }}>
                        {dev ? (
                            <div>
                                <TextField name="key" floatingLabelText="Key" value={key} onChange={this.onChange} />
                                <TextField
                                    name="value"
                                    floatingLabelText="Value"
                                    value={value || ''}
                                    onChange={this.onChange}
                                />
                            </div>
                        ) : (
                            <div style={{ ...yCenter, flexWrap: 'wrap' }}>
                                <SelectField name="key" floatingLabelText="Property" value={key}>
                                    {KEY_OPTIONS.map(option => (
                                        <MenuItem
                                            key={option.value}
                                            value={option.value}
                                            onTouchTap={() => this.onKeyChange(option.value)}
                                            primaryText={option.label}
                                        />
                                    ))}
                                </SelectField>
                                {key === 'channels' ? (
                                    <SelectField name="value" floatingLabelText="Channel" value={value}>
                                        <MenuItem
                                            value={emptyOption}
                                            onTouchTap={() =>
                                                this.setState({
                                                    value: emptyOption,
                                                })
                                            }
                                            primaryText="None"
                                        />
                                        {CHANNELS.map(channel => (
                                            <MenuItem
                                                key={_.head(channel)}
                                                value={channel}
                                                onTouchTap={() =>
                                                    this.setState({
                                                        value: channel,
                                                    })
                                                }
                                                primaryText={_.head(channel)}
                                            />
                                        ))}
                                    </SelectField>
                                ) : (
                                    <TextField
                                        name="value"
                                        floatingLabelText={key === 'matchPageLink' ? 'Link' : 'Value'}
                                        value={value || ''}
                                        onChange={this.onChange}
                                    />
                                )}
                            </div>
                        )}
                        <FlatButton
                            disabled={!canSubmit || !valueChanged}
                            primary
                            label="Save"
                            onTouchTap={this.save}
                        />
                        {valueChanged ? (
                            <IconButton tooltip="Undo" onTouchTap={this.undo}>
                                <UndoIcon />
                            </IconButton>
                        ) : (
                            <div style={{ width: 48 }}>
                                <span />
                            </div>
                        )}
                        <Snackbar
                            open={Boolean(snackBarText)}
                            message={snackBarText}
                            contentStyle={!success ? { color: 'red' } : undefined}
                        />
                    </div>
                </div>
            );
        }
    },
);

const EventList = withQueryParams('ttId', 'appName', 'property')(
    class EventList extends React.PureComponent {
        componentDidMount() {
            this.updateEvents();
            if (!KEY_OPTIONS.find(option => option.key === this.props.property)) {
                KEY_OPTIONS.push({ label: this.props.property, value: this.props.property });
            }
        }

        state = {
            date: new Date(),
            events: [],
            eventId: null,
            limit: 20,
            skip: 0,
            appName: this.props.appName,
        };

        onDateChange = (e, value) => {
            this.setState({ date: value, skip: 0 });
            const { limit, appName } = this.state;
            const { ttId } = this.props;
            this.updateEvents(value, limit, 0, ttId, appName);
        };

        updateEvents = (
            date = this.state.date,
            limit = this.state.limit,
            skip = this.state.skip,
            ttId = this.props.ttId,
            appName = this.state.appName,
        ) => {
            const fromDate = moment(date).local();
            if (date) {
                req.get(`${ss2}/events-v2`)
                    .query({
                        fromDate: fromDate.format('YYYY-MM-DD'),
                        appName: appName ? `dk.releaze.livecenter.${appName}` : undefined,
                        skip,
                        ttId,
                        limit,
                    })
                    .then(res => {
                        const events = Array.isArray(res.body.events) ? res.body.events : [];
                        this.setState({ events });
                    });
            } else {
                this.setState({ events: [] });
            }
        };

        updateEventsDelayed = _.debounce(this.updateEvents, 1 * 1000);

        onAppNameChange = appName => {
            this.setState({ appName });
            this.updateEventsDelayed();
        };

        nextPage = () => {
            const { ttId } = this.props;
            const { limit, skip, date, appName } = this.state;
            const nextSkip = skip + limit;
            this.setState({ skip: nextSkip });
            this.updateEvents(date, limit, nextSkip, ttId, appName);
        };

        prevPage = () => {
            const { ttId } = this.props;
            const { limit, skip, date, appName } = this.state;
            const nextSkip = Math.max(0, skip - limit);
            this.setState({ skip: nextSkip });
            this.updateEvents(date, limit, nextSkip, ttId, appName);
        };

        renderEvents() {
            const { events, appName } = this.state;
            if (events.length) {
                return (
                    <Paper>
                        {events.map(event => (
                            <div key={event.eventId}>
                                <EventInput event={event} appName={appName} onSave={this.updateEvents} />
                                <Divider />
                            </div>
                        ))}
                    </Paper>
                );
            }
            return <p>No events</p>;
        }

        renderPagintation = () => {
            const { events, limit, skip } = this.state;
            const canGoNext = events.length === limit;
            const canGoPrev = skip !== 0;
            return (
                <div style={yCenter}>
                    <IconButton disabled={!canGoPrev} onTouchTap={this.prevPage}>
                        <PrevArrow />
                    </IconButton>
                    <IconButton disabled={!canGoNext} onTouchTap={this.nextPage}>
                        <NextArrow />
                    </IconButton>
                    {skip + 1}-{skip + Math.min(limit, events.length)}
                </div>
            );
        };

        render() {
            const { dev, appName } = this.props;
            if (!dev && !appName) {
                return <div>Incorrect URL</div>;
            }
            return (
                <div>
                    {dev && (
                        <TextField
                            name="appName"
                            floatingLabelText="Application name"
                            value={this.state.appName}
                            errorText={!this.state.appName && 'Required'}
                            onChange={(e, val) => this.onAppNameChange(val)}
                        />
                    )}
                    <div>
                        <SelectField floatingLabelText="Property" value={this.props.property}>
                            {KEY_OPTIONS.map(option => (
                                <MenuItem
                                    key={option.value}
                                    value={option.value}
                                    primaryText={option.label}
                                    onTouchTap={() => addToQuery('property', option.value)}
                                />
                            ))}
                        </SelectField>
                    </div>
                    <DatePicker
                        id="date"
                        value={this.state.date}
                        floatingLabelText="From date"
                        onChange={this.onDateChange}
                    />
                    {this.renderEvents()}
                    {this.renderPagintation()}
                </div>
            );
        }
    },
);

const Scene = () => (
    <div style={{ paddingTop: 24 }}>
        <EventList />
    </div>
);

export default Scene;



/** WEBPACK FOOTER **
 ** ../src/dash/front/admin/components/KeyValSS2/index.js
 **/